"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStyles = void 0;
var react_1 = __importDefault(require("react"));
var clsx_1 = __importDefault(require("clsx"));
var styles_1 = require("@material-ui/core/styles");
var core_1 = require("@material-ui/core");
var ProficiencyProgressBar_1 = __importDefault(require("../ProficiencyProgressBar"));
exports.useStyles = styles_1.makeStyles(function (theme) {
    return styles_1.createStyles({
        root: {
            display: 'block',
            maxWidth: 180,
            width: '100%',
            padding: 0,
            borderRadius: 10,
        },
        layers: {
            zIndex: 1,
            '&::before': {
                top: 10,
                left: '6%',
                width: '88%',
                height: '100%',
                content: '""',
                zIndex: 1,
                position: 'absolute',
                backgroundColor: theme.palette.background.paper,
                borderRadius: 10,
                boxShadow: '0 1px 3px rgba(0, 0, 0, .12), 0 1px 2px rgba(0, 0, 0, .24)',
            },
            '&::after': {
                top: 5,
                left: '3%',
                width: '94%',
                height: '100%',
                content: '""',
                zIndex: 1,
                position: 'absolute',
                backgroundColor: theme.palette.background.paper,
                borderRadius: 10,
                boxShadow: '0 3px 6px rgba(0, 0, 0, .15), 0 2px 4px rgba(0, 0, 0, .12)',
            },
        },
        paper: {
            padding: theme.spacing(3, 3, 2, 3),
            borderRadius: 10,
            width: '100%',
            zIndex: 2,
            backgroundColor: theme.palette.background.paper,
            transition: theme.transitions.create(['box-shadow'], {
                duration: theme.transitions.duration.standard,
            }),
            boxShadow: '0 10px 20px rgba(0, 0, 0, .15), 0 3px 6px rgba(0, 0, 0, .10)',
            '&:hover': {
                boxShadow: '0 20px 40px rgba(0, 0, 0, .2)',
            },
        },
        name: {
            marginTop: theme.spacing(2),
            marginBottom: theme.spacing(1),
            minHeight: 40,
            lineHeight: 1.3,
        },
        cardCount: {
            marginTop: theme.spacing(1),
        },
        progress: {
            marginTop: theme.spacing(4),
        },
        badgeRoot: {
            width: '100%',
        },
        badge: {
            height: 26,
            minWidth: 26,
            borderRadius: 13,
            fontSize: '.85rem',
            zIndex: 3,
        },
    });
});
var DeckCard = function (_a) {
    var classNameProp = _a.className, deck = _a.deck, _b = _a.dueCount, dueCount = _b === void 0 ? 0 : _b, other = __rest(_a, ["className", "deck", "dueCount"]);
    var classes = exports.useStyles();
    var cardCount = deck.cards.length;
    var studentCount = 0;
    var isTeacher = deck.roles.includes('teacher');
    if (isTeacher && deck.students) {
        studentCount = deck.students.length;
    }
    return (react_1.default.createElement(core_1.ButtonBase, __assign({ disableRipple: true, className: clsx_1.default(classes.root, classNameProp) }, other),
        react_1.default.createElement(core_1.Badge, { component: "div", classes: { root: classes.badgeRoot, badge: classes.badge }, badgeContent: dueCount, color: "error" },
            react_1.default.createElement("div", { className: classes.layers }),
            react_1.default.createElement(core_1.Paper, { className: classes.paper },
                react_1.default.createElement(core_1.Typography, { className: classes.name }, deck.name),
                react_1.default.createElement(core_1.Typography, { variant: "caption", className: classes.cardCount },
                    cardCount > 0 ? cardCount : 'No',
                    " card",
                    cardCount === 1 ? '' : 's'),
                react_1.default.createElement("div", { className: classes.progress },
                    !isTeacher && typeof deck.proficiency !== 'undefined' && (react_1.default.createElement(ProficiencyProgressBar_1.default, { value: deck.proficiency })),
                    isTeacher && (react_1.default.createElement(core_1.Typography, { variant: "caption", className: classes.cardCount },
                        studentCount > 0 ? studentCount : 'No',
                        " student",
                        studentCount === 1 ? '' : 's')))))));
};
exports.default = DeckCard;
//# sourceMappingURL=DeckCard.js.map